import { render, staticRenderFns } from "./ControlSystem.vue?vue&type=template&id=3b74a2b5&scoped=true&"
import script from "./ControlSystem.vue?vue&type=script&lang=js&"
export * from "./ControlSystem.vue?vue&type=script&lang=js&"
import style0 from "./ControlSystem.vue?vue&type=style&index=0&id=3b74a2b5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b74a2b5",
  null
  
)

export default component.exports